/* globals translation */

import { accordion } from './functions';

if (document.body.classList.contains('single-video')) {
  const toggleVariableProducts = () => {
    const toggleLinks = Array.from(document.querySelectorAll('.video-toggle-product-variation'));
    if (toggleLinks) {
      toggleLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const { productId } = link.dataset;
          const button = link;
          const variationRows = Array.from(document.querySelectorAll(`.product-parent-${productId}`));
          if (variationRows) {
            variationRows.forEach((variationRow) => {
              const row = variationRow;
              if (row.style.display === 'none') {
                row.style.display = 'block';
                button.innerText = translation.hide_variations;
              } else {
                row.style.display = 'none';
                button.innerText = translation.show_variations;
              }
            });
          }
        });
      });
    }
  };
  const modifyVideoContainerHeight = () => {
    const videoWrapper = document.querySelector('.video-product-container > .video-wrapper');
    const { parentNode } = videoWrapper;
    parentNode.style.height = `${videoWrapper.clientHeight}px`;
  };

  toggleVariableProducts();
  accordion();
  modifyVideoContainerHeight();
  window.addEventListener('resize', modifyVideoContainerHeight);
}
